import {
  useCallback, useEffect, useRef, useState,
} from 'react'
import cn from 'classnames'
import { useDispatch, useSelector } from 'react-redux'
import { NavLink } from 'react-router-dom'

import { IndividualsPanel } from '@src/components/IndividualsPanel/IndividualsPanel'
import style from '@src/pages/MovingNewAddress/MovingNewAddress.module.scss'
import { Footer } from '@src/components/Footer/Footer'
import { MovingNewAddressForm } from '@src/pages/MovingNewAddress/MovingNewAddressForm'
import { AppDispatch } from '@src/store/store'
import { ReturnBtn } from '@src/components/Button/ReturnBtn'
import { Modal } from '@src/components/common/Modal/Modal'
import { setIsSuccessBlock } from '@src/store/ducks/tariffs/reducer'
import { Button } from '@src/components/Button/Button'
import {
  selectAddressIsLoadingChange,
  selectAddressIsSuccessChange,
  selectSuccessMoving,
} from '@src/store/ducks/address/selectors'
import { resetAddress } from '@src/store/ducks/address/reducer'
import { changeAddress } from '@src/store/ducks/address/thunks'
import { setPageTitle } from '@src/store/ducks/app/reducer'

export const MovingNewAddress = () => {
  const formRef = useRef<any>()
  const dispatch = useDispatch<AppDispatch>()
  const isSuccessMoving = useSelector(selectSuccessMoving)
  const isLoadingChange = useSelector(selectAddressIsLoadingChange)
  const isSuccessChange = useSelector(selectAddressIsSuccessChange)
  const [isOpenModal, setIsOpenModal] = useState(false)

  useEffect(() => { dispatch(setPageTitle('Переезд - проверка адреса на возможность подключения')) }, [dispatch])

  useEffect(() => () => {
    dispatch(resetAddress())
  }, [dispatch])

  const handleClose = useCallback(() => {
    setIsOpenModal(false)
    dispatch(setIsSuccessBlock(false))
  }, [dispatch])

  return (
    <div>
      <IndividualsPanel />
      <div className={cn(style.movingNewAddressContainer, 'container')}>
        <ReturnBtn type="secondary">Вернуться</ReturnBtn>
        <div className={style.movingNewAddressBlock}>
          <h2 className={style.mainTitle}>Переезд</h2>
          <div className={style.description}>
            Проверьте адрес, чтобы убедиться, что дом подключен к нашей сети
          </div>
          <MovingNewAddressForm setIsOpenModal={setIsOpenModal} formRef={formRef} />
        </div>
        <Modal isOpen={isOpenModal} close={handleClose}>
          {!!isSuccessMoving && !isSuccessChange && (
            <>
              <div className={style.box1}>
                <h3>
                  По данному адресу
                  <span> возможно </span>
                  подключение!
                </h3>
                <Button
                  className={style.btn}
                  type="primary"
                  loading={isLoadingChange}
                  // eslint-disable-next-line max-len
                  onClickFunc={() => dispatch(changeAddress(`${formRef.current.values.street.value}, д.${formRef.current.values.house}${formRef.current.values.corpus && `корпус ${formRef.current.values.corpus}`}`))}
                >
                  Отправить заявку
                </Button>
              </div>
            </>
          )}
          {!isSuccessMoving && !isSuccessChange && (
            <div className={cn(style.box1, style.failedConnection)}>
              <h4>
                Уважаемый абонент, к сожалению, этот дом
                не подключен к сети КОСМОС Телеком
              </h4>
              <div className={style.description}>
                Вы можете остаться с нами, и смотреть интерактивное телевидение
                в приложении «COSMOS TV», для этого нужен лишь интернет.
                Подробности на сайте:
                {' '}
                <a
                  href="https://cosmostv.com"
                >
                  <span>https://cosmostv.com</span>
                </a>
              </div>
              <NavLink to="/moving-new-address" style={{ marginTop: 10 }}>
                <Button
                  onClickFunc={handleClose}
                  className={style.btn}
                  type="primary"
                >
                  Вернуться назад
                </Button>
              </NavLink>
            </div>
          )}
          {isSuccessChange && (
            <>
              <div className={style.box1}>
                <h3>
                  Ваш заявка была
                  <span> успешно </span>
                  оформлена!
                </h3>
                <NavLink to="/" style={{ marginTop: 10 }}>
                  <Button
                    className={style.btn}
                    type="primary"
                  >
                    В личный кабинет
                  </Button>
                </NavLink>
              </div>
            </>
          )}
        </Modal>
      </div>
      <Footer />
    </div>
  )
}
